module.exports = __webpack_public_path__ + "img/resized-20160625-210400.bcbde209.jpg";